__turbopack_context__.v({
  "active": "ProducerMarker-module-scss-module__NKHSKW__active",
  "hidden": "ProducerMarker-module-scss-module__NKHSKW__hidden",
  "icon": "ProducerMarker-module-scss-module__NKHSKW__icon",
  "is-active": "ProducerMarker-module-scss-module__NKHSKW__is-active",
  "name": "ProducerMarker-module-scss-module__NKHSKW__name",
  "producer-marker": "ProducerMarker-module-scss-module__NKHSKW__producer-marker",
  "producer-marker-card": "ProducerMarker-module-scss-module__NKHSKW__producer-marker-card",
});
